import { TEditPortionAction, EditPortionActionTypes } from './editPortionActions';
import { IEditPortionState } from './editPortionContext';

export const editPortionReducer = (state: IEditPortionState, action: TEditPortionAction): IEditPortionState => {
	switch (action.type) {
		case EditPortionActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				portionId: action.payload.portionId,
				nameOfPortion: action.payload.nameOfPortion,
				price: action.payload.price,
				priceStrategy: action.payload.priceStrategy,
				externalId: action.payload.externalId,
				isProtectedFromSync: action.payload.isProtectedFromSync,
				isDisabled: action.payload.isDisabled,
				posName: action.payload.posName,
				articleNumber: action.payload.articleNumber,
				fetchedCustomers: action.payload.fetchedCustomers,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: action.payload.fetchedRestaurants,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				nameOfDish: action.payload.nameOfDish,
				dishId: action.payload.dishId,
				isCreatedOnPos: action.payload.isCreatedOnPos,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
				translations: action.payload.translations,
			};
		case EditPortionActionTypes.CHANGE_NAME_OF_PORTION:
			return {
				...state,
				nameOfPortion: action.payload.nameOfPortion,
			};
		case EditPortionActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case EditPortionActionTypes.CHANGE_PRICE_STRATEGY:
			return {
				...state,
				priceStrategy: action.payload.priceStrategy,
			};
		case EditPortionActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditPortionActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC:
			return {
				...state,
				isProtectedFromSync: !state.isProtectedFromSync,
			};
		case EditPortionActionTypes.TOGGLE_IS_DISABLED:
			return {
				...state,
				isDisabled: !state.isDisabled,
			};
		case EditPortionActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditPortionActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditPortionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case EditPortionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
